export const SAVE = 'question/SAVE'
export const RESET = 'question/RESET'




// WEBPACK FOOTER //
// ./src/question/actionTypes.js